import React from 'react'
import { Link } from 'react-router-dom'
import { useAdaptiveImageTone } from '../../hooks/useAdaptiveImageTone'

function Breadcrumb({ title, description, bgImage }) {
    const image = bgImage || '/assets/img/bg/breadcumb-bg.jpg'
    const palette = useAdaptiveImageTone(image)

    return (
        <div
            key={image}
            className={`breadcumb-wrapper background-image twa-banner-tone twa-banner-tone--${palette.tone}`}
            data-bg-src={image}
            style={{
                '--twa-banner-image': `url("${image}")`,
                backgroundImage: `url("${image}")`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                '--twa-banner-text': palette.textColor,
                '--twa-banner-muted': palette.mutedColor,
                '--twa-banner-accent': palette.accentColor,
                '--twa-banner-shadow': palette.shadow,
                '--twa-btn-bg': palette.btnPrimaryBg,
                '--twa-btn-color': palette.btnPrimaryText,
                '--twa-btn-border': palette.btnPrimaryBorder,
                '--twa-btn-hover-bg': palette.btnPrimaryHoverBg,
                '--twa-btn-hover-color': palette.btnPrimaryHoverText,
                '--twa-btn2-bg': palette.btnSecondaryBg,
                '--twa-btn2-color': palette.btnSecondaryText,
                '--twa-btn2-border': palette.btnSecondaryBorder,
                '--twa-btn2-hover-bg': palette.btnSecondaryHoverBg,
                '--twa-btn2-hover-color': palette.btnSecondaryHoverText,
            }}
        >
            <div className="twa-banner-overlay" style={{ background: palette.overlay }} aria-hidden="true" />
            <div className="container">
                <div className="breadcumb-content">
                    <h1 className="breadcumb-title">{title}</h1>
                    {description && <p className="breadcumb-desc">{description}</p>}
                    <ul className="breadcumb-menu">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>{title}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Breadcrumb
